import {useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {useEffect, useState} from 'react'
import {getExCRUD} from '../../../../role-access/role-setting-list/core/_requests'
import {useAuth} from '../../../../../auth'
import {EmployeeListFilter} from './EmployeeListFilter'
import {useQueryResponse, useQueryResponseData} from '../../core/QueryResponseProvider'
import {getData} from '../../core/_requests'
import * as XLSX from 'xlsx'

const EmployeeListToolbar = () => {
  const {currentUser} = useAuth()
  const navigate = useNavigate()
  const users = useQueryResponseData()
  const {query} = useQueryResponse()
  const [isExporting, setIsExporting] = useState(false)

  const [roleaccess, setroleaccess] = useState<any>([])
  useEffect(() => {
    getExCRUD(currentUser?.roleId, 3).then((res: any) => {
      var crudres = res.data?.Data[0]
      setroleaccess(crudres)
    })
  }, [])

  const handleDownloadExcel = async () => {
    try {
      setIsExporting(true)
      const exportQuery = (query || '')
        .replace(/items_per_page=\d+/, 'items_per_page=10000')
        .replace(/page=\d+/, 'page=1')

      const response = await getData(exportQuery)
      const exportUsers = response?.data && response.data.length > 0 ? response.data : users

      const formattedData = exportUsers.map((user: any) => {
        const dt = Number(user.device_type)
        const platformStr = dt === 1 ? 'Android' : dt === 2 ? 'iOS' : 'Other'
        const planStr = Array.isArray(user.subscribedPlans) ? user.subscribedPlans.join(', ') : ''
        const locationStr = [user.town, user.location, user.district, user.state].filter(Boolean).join(', ')

        return {
          UID: user.primaryId || user.id || '',
          'User Name': user.name || '',
          Mobile: user.mobile || '',
          Email: user.email || '',
          Platform: platformStr,
          Status: user.status || '',
          'User Type': user.userType?.name || '',
          Plans: planStr,
          Location: locationStr,
          'Registered Date': user.created || '',
        }
      })

      const worksheet = XLSX.utils.json_to_sheet(formattedData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Users')
      
      const today = new Date().toISOString().slice(0, 10)
      XLSX.writeFile(workbook, `Users_List_${today}.xlsx`)
    } catch (error) {
      console.error('Error exporting users to Excel:', error)
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <div className='d-flex justify-content-end align-items-center' data-kt-user-table-toolbar='base'>
      <EmployeeListFilter />
      <button
        type='button'
        className='btn btn-light-success me-3'
        onClick={handleDownloadExcel}
        disabled={isExporting}
      >
        <i className='fas fa-file-excel me-2 fs-5'></i>
        {isExporting ? 'Exporting...' : 'Download Excel'}
      </button>
    </div>
  )
}

export {EmployeeListToolbar}
